import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const PhysicalCheckBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-violet-500 text-white">
      {t('component:badge.physicalCheck')}
    </Badge>
  );
};
